import type { PaletteColor } from '@hrms/shared'
import type { ReactNode } from 'react'
import { cn } from '../../lib/cn.ts'

/** Status lozenge. */
export function Lozenge({
  color,
  className,
  children,
}: {
  color: PaletteColor
  className?: string
  children: ReactNode
}) {
  return (
    <span
      data-color={color}
      className={cn(
        'inline-flex items-center rounded-lozenge bg-cb px-[7px] py-px text-xs leading-[1.5] font-semibold whitespace-nowrap text-cf',
        className,
      )}
    >
      {children}
    </span>
  )
}
